import { Icon } from '@ksyos/design-system';
import { ServiceType } from '@common/enums';
import type { AdminProcess } from './adminProcessDetailsTypes';
import { StatusLabelManager } from '../../elements/StatusLabelManager';

interface IAdminProcessDetailsHeaderProps {
    adminProcess: AdminProcess;
    requestId?: string;
    title: string;
}

function getIconType(props: IAdminProcessDetailsHeaderProps) {
    if (props.adminProcess.service.serviceType === ServiceType.referralSmall) {
        return ServiceType.referral;
    }
    if (props.adminProcess.service.serviceType === ServiceType.other) {
        return undefined;
    }

    return props.adminProcess.service.serviceType;
}

export function AdminProcessDetailsHeader(props: IAdminProcessDetailsHeaderProps) {
    return (
        <>
            <span className="process-icon first">
                <Icon
                    color="secondary"
                    icon={getIconType(props)}
                />
            </span>
            <div className="form-header level">
                <div className="form-header__title level-left">
                    <h2>{props.title}</h2>
                    <StatusLabelManager
                        badge
                        request={props.adminProcess}
                    />
                </div>
                <div className="form-header__details level-right">
                    <div className="form-header--process-details">
                        <span className="form-header--pid">PID {props.adminProcess.processId}</span>
                    </div>
                </div>
            </div>
        </>
    );
}
